// Recursive function to render JSON with custom colors
const renderJson = (obj: any, indent = 0) => {
  if (typeof obj !== 'object' || obj === null) {
    // Primitive value
    return <span style={{ color: '#CE9178' }}>{JSON.stringify(obj)}</span>;
  }

  if (Array.isArray(obj)) {
    return (
      <span>
        [<br />
        {obj.map((item, i) => (
          <div key={i} className="ml-4">
            {renderJson(item, indent + 4)}
            {i < obj.length - 1 ? ',' : ''}
          </div>
        ))}
        ]
      </span>
    );
  }

  return (
    <span>
      {'{'}
      <br />
      {Object.entries(obj).map(([key, value], i, arr) => (
        <div key={key} className="ml-4 my-1">
          <span style={{ color: '#9CDCFE' }}>&quot;{key}&quot;</span>:{' '}
          {renderJson(value, indent + 4)}
          {i < arr.length - 1 ? ',' : ''}
        </div>
      ))}
      {'}'}
    </span>
  );
};

const ApiDocumentation = ({
  apiDocumentation,
}: {
  apiDocumentation: {
    title: string;
    method: string;
    requestPath?: string;
    description: string;
    requestExample?: Record<string, any> | undefined;
    responseExample: Record<string, any> | Record<string, any>[];
    parameters?: {
      name: string;
      type: string;
      required: boolean;
      description: string;
    }[];
    statusCode: string;
  };
}) => {
  return (
    <div className="p-5 pt-0 space-y-5">
      {!!apiDocumentation?.requestPath && (
        <div>
          <span className="text-white/90 mb-2 block">Request Path:</span>
          <pre className="text-sm font-mono p-4 rounded-lg overflow-auto border border-white/10 bg-gradient-to-r from-white/5 to-white/0">
            {apiDocumentation?.requestPath}
          </pre>
        </div>
      )}
      {!!apiDocumentation.requestExample && (
        <div>
          <span className="text-white/90 mb-2 block">Request Body (JSON):</span>
          <pre className="text-sm font-mono p-4 rounded-lg overflow-auto border border-white/10 bg-gradient-to-r from-white/5 to-white/0">
            {renderJson(apiDocumentation.requestExample)}
          </pre>
        </div>
      )}
      {!!apiDocumentation.responseExample && (
        <div>
          <span className="text-white/90 mb-2 block">Response (200 OK):</span>
          <pre className="text-sm font-mono p-4 rounded-lg overflow-auto border border-white/10 bg-gradient-to-r from-white/5 to-white/0">
            {renderJson(apiDocumentation.responseExample)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default ApiDocumentation;
